import uniqueId from 'lodash/uniqueId';
import trafficParser from '../elements/traffic';
import actionFactory from '../props/action';
import paddingModifier from '../props/padding-modifier';
import align, { ALIGNMENT } from '../props/align';
import { WEIGHT } from '../../const';

/**
 * Парсер блока div-traffic-block
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-traffic-block.json
 * @param  {Object} block
 * @return {Object}
 */
export default (function (block) {
    var items = (block.items || []).map(trafficParser).filter(Boolean);

    if (!items.length) {
        return null;
    }

    return {
        items: items,
        alignment: align(block.alignment, ALIGNMENT.left),
        action: actionFactory(block),
        paddingModifier: paddingModifier(block),
        type: block.type,
        id: uniqueId('block_'),
        weight: WEIGHT.traffic
    };
});